<template>
    <div class="publish_div">
        <input type="text" placeholder="请输入文章标题" class="publish_title_input" v-model="title">
        <div style="margin: 10px;">
            <el-tag
                    :key="tag"
                    v-for="tag in selectTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                {{tag.name}}
            </el-tag>
            <el-popover
                    placement="bottom"
                    width="400"
                    title="选择标签"
                    trigger="click">
                <div>
                    <el-tag type="success" v-for="tag in systemTags" :key="tag['id']" @click="add_tag(tag)">
                        {{tag.name}}
                    </el-tag>
                </div>
                <el-button slot="reference" class="button-new-tag" size="small">+ 添加标签</el-button>
            </el-popover>
        </div>
        <!--<MarkdownEditor class="editor_component"-->
        <!--:placeholder="'写点什么吧....'"-->
        <!--:preview="preview"-->
        <!--:text="content"-->
        <!--@text="get_content">-->
        <!--</MarkdownEditor>-->
        <div class="editor_component">
            <CKEditor :text="content" :mode="'edit'" @text="get_content"></CKEditor>
        </div>
        <div class="publish_tools">
            <div class="publish_tags">
                <span class="publish_tag">
                    保存至:
                </span>
                <span class="publish_tag publish_tag_active">
                    {{active_column_name}}
                </span>
                <!--<span class="publish_tag"-->
                <!--@click="tab_active('快乐生活')"-->
                <!--:class="[tag=='快乐生活' ? 'publish_tag_active' : '']"-->
                <!--&gt;-->
                <!--快乐生活-->
                <!--</span>-->
            </div>
            <p v-if="post_info.is_published" class="pubilshed_type_p pubilshed">已发布</p>
            <p v-else class="pubilshed_type_p no-pubilshed">未发布</p>
            <div>
                封面:
                <label for="new_upload_cover">
                    <img v-if="post_info.cover_url" class="post_cover_img" :src="post_info.cover_url">
                    <img v-else class="post_cover_img">
                </label>
                <input type="file" id="new_upload_cover" @change="upload_image_to_odoo($event)">
            </div>
            <div class="publish_operation_tools">
                <!--<button class="publish_button publish_preview_button" @click="tab_preview()" v-show="!preview">预览-->
                <!--</button>-->
                <!--<button class="publish_button publish_preview_button" @click="tab_preview()" v-show="preview">取消预览-->
                <!--</button>-->
                <button class="publish_button" @click="modify()">保存</button>
                <button v-if="!post_info.is_published" class="publish_button" @click="publish()">发布</button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import MarkdownEditor from '@/components/common_components/markdown_editor/markdown_edit_preview_together.vue'
    import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'

    import postApi from '@/api/post/post.js'
    import tagApi from '@/api/tag/tag.js'
    import {mapState, mapActions, mapGetters} from 'vuex'
    import Upload from '@/api/upload/upload.js'

    export default {
        props: {
            post_info: {
                type: Object,
                require: true
            }
        },
        components: {
            CKEditor,
            MarkdownEditor
        },
        data: function () {
            return {
                tag: '成长记忆',
                tag_dict: {
                    '成长记忆': 'weblogs',
                    '快乐生活': 'moments'

                },
                preview: true,
                content: '',
                title: '',
                post_id: 0,

                systemTags: [],
                selectTags: [],
            }
        },
        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                active_column_id: state => state.post.active_column_id,
                post_column: state => state.post.post_column,
                // post_info: state => state.post.post_information,
            }),
            ...mapGetters({
                active_column_name: 'post/active_column_name',
            })
        },
        methods: {
            ...mapActions({
                change_show_state: 'loginState/change_show_state',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class',
                change_cover_by_url: 'post/change_cover_by_url'
            }),
            handleClose(tag) {
                this.selectTags.splice(this.selectTags.indexOf(tag), 1);
            },
            add_tag(tag) {
                if (this.selectTags.indexOf(tag) == -1) {
                    this.selectTags.push(tag)
                }
            },
            tab_active: function (tag) {
                this.tag = tag
            },
            tab_preview: function () {
                this.preview = !this.preview
            },
            get_content: function (content) {
                this.content = content
            },
            modify: async function () {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {
                    if (!this.active_column_id) {
                        this.change_warning_message('请先选择栏目！');
                        this.change_warning_bar_style_class('alert');
                    } else {
                        let res = await postApi.modify_post({
                            post_id: this.post_id,
                            title: this.title,
                            content: this.content,
                            column_id: this.active_column_id,
                            selectTags: this.selectTags,
                            cover_url: this.post_info.cover_url,
                            // type: this.tag_dict[this.tag],
                            // 这个参数好像是个预留参数暂时没用的样子。
                            // 'beans': 0
                        })
                        let data = JSON.parse(res.data.result);
                        console.log(data)
                        this.change_warning_message(data.message);
                        if (data.code === 'success') {
                            this.change_warning_bar_style_class('success');
                        } else {
                            this.change_warning_bar_style_class('alert');
                        }

                    }


                }
            },
            publish: async function () {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {
                    if (!this.active_column_id) {
                        this.change_warning_message('请先选择栏目！');
                        this.change_warning_bar_style_class('alert');
                    } else {
                        let res = await postApi.modify_post({
                            post_id: this.post_id,
                            title: this.title,
                            content: this.content,
                            column_id: this.active_column_id,
                            is_published: true,
                            selectTags: this.selectTags,
                            cover_url: this.post_info.cover_url,
                            // type: this.tag_dict[this.tag],
                            // 这个参数好像是个预留参数暂时没用的样子。
                            // 'beans': 0
                        })
                        let data = JSON.parse(res.data.result);
                        console.log(data)
                        this.change_warning_message(data.message);
                        if (data.code === 'success') {
                            this.change_warning_bar_style_class('success');
                            this.$router.push({name: 'post', params: {id: data.post.number}})
                        } else {
                            this.change_warning_bar_style_class('alert');
                        }

                    }


                }
            },
            upload_image_to_odoo: async function (event) {
                let formData = new FormData();
                formData.append('file', event.target.files[0]);
                let response = await Upload.upload_file_to_odoo(formData);
                let new_cover_url = response.data.imgUrl
                this.change_cover_by_url(new_cover_url)
            },
        },
        watch: {
            post_info: function () {
                this.content = this.post_info.content;
                localStorage.setItem('edit_post_content', this.post_info.content)
                this.title = this.post_info.title;
                this.post_id = this.post_info.id;
                this.selectTags = this.post_info.tags;
            }
        },
        mounted() {
            this.content = this.post_info.content;
            localStorage.setItem('edit_post_content', this.post_info.content)
            this.title = this.post_info.title;
            this.post_id = this.post_info.id;
            this.selectTags = this.post_info.tags;
            tagApi.get_tags().then((res) => {
                this.systemTags = res.data
            })
        }
    }

</script>
<style type="text/css" scoped>
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .publish_div {
        /*width: 660px;*/
        height: calc(100vh - 120px);
        /*margin: auto;*/
        border: white 1px solid;

        padding: 18px 30px;
        display: flex;
        flex-direction: column;
    }

    .publish_title_input {
        font-size: 20px;
        padding: .375rem .75rem;
        width: 100%;
        line-height: 1.5;
        /*border: 0;*/
        border-bottom: #ccc 1px solid;
        outline: none;
        box-shadow: none;
        resize: none;
        color: #333;
        background: #f9f9f9;
    }

    .editor_component {
        margin-bottom: 120px;
    }

    .publish_tools {
        position: fixed;
        width: 50%;
        bottom: 0;
        left: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        margin-top: 10px;
        background: #f9f9f9;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
    }

    .publish_tags {
        color: #333;
        font-size: 14px;
        font-weight: 700;
        display: flex;
    }

    .publish_tag {
        /*font-weight: 500;*/
        padding: 2px 10px;
        margin-right: 10px;
        border-radius: 20px;
        cursor: pointer;
    }

    .publish_tag_active {
        color: #fff;
        background: #4e5d63;
    }

    .publish_operation_tools {
        display: flex;

    }

    .publish_button {
        padding: 6px 20px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        margin-right: 5px;
    }

    .publish_button:hover {
        color: #fff;
        background: #069a75;
    }

    .publish_preview_button {
        background-color: #fff;
        color: #66CCFF;
        border-color: #66CCFF;
    }

    .publish_preview_button:hover {
        color: #fff;
        background-color: #66CCFF;
    }

    .pubilshed_type_p {
        min-height: 32px;
        width: 80px;
        margin-top: 17px;
        color: #fff;
        padding: 7px 17px;
        border-radius: 100px;
    }

    .pubilshed {
        background: #59cf4a;
    }

    .no-pubilshed {
        background: #f5c6cb;
    }

    #new_upload_cover {
        display: none;
    }

    .post_cover_img {
        width: 80px;
        height: 80px;
        /*border-radius: 25px;*/
        cursor: pointer;
    }

</style>
